import { ReleasesList } from "./ReleasesList";

export default ReleasesList;
